import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Spin, Table, Button, Drawer, Modal, FormModel, InputNumber, Icon, Form, Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { fmtMsg, GLUtil, MessageHelper, ActionItem } from "commonui";
import { LessonPlanItemType, ComponentTaughtType, LessonPlanColumns, PlaylistItemType } from "@/models/master-plan";
import { ApplicationViews, LessonPlanVersionStatus, ContentGroupEnum, MediaSlot, Activity } from "@/util/enum";
import { MethodologyTypeItemsWithAll, EstimatedTimeRowKey, TransitionRowKey, QuestionOrConversationRowKey } from "@/util/constants";
import MasterPlanState from "@/modules/master-plan";
import { VersionGroupModule } from "@/modules/versiongroup";
import { LessonPlanLocale, CommonLocale } from "@/locales/localeid";
import PageTitle from "@/components/page-title/page-title.vue";
import UnitInfo from "../components/unit-info/unit-info.vue";
import TransitionCell from "./components/transition-cell/transition-cell";
import LessonPlanCell from "./components/lesson-plan-cell/lesson-plan-cell";
import TransitionDetail from "./components/transition-detail/transition-detail.vue";
import SwitchModal from "./components/switch-modal/switch-modal.vue";
import { disabledDueToAccessLevel, getRouteAccessLevel, second2Minute } from "@/util/func";
import { Paths } from "@/util/paths";
import MatIcon from "@/commonui/components/mat-icon/mat-icon.vue";
import { PdfIcon } from "@/style/index";
import { LessonPlanActivitiesService } from "@/services/lesson-plan-activities";
let MasterPlanManagement = class MasterPlanManagement extends Vue {
    constructor() {
        super(...arguments);
        this.masterPlanModule = getModule(MasterPlanState);
        this.versionGroupModule = VersionGroupModule; // for watch need to create local reference
        this.lessonPlanActivitiesService = LessonPlanActivitiesService();
        this.view = ApplicationViews.LessonPlanVersion;
        this.dataChanged = false;
        this.dataChanged4Detail = false;
        this.editModalVisible = false;
        this.displayTransitionDetail = false;
        this.columns = [
            {
                title: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanColumnComponentTitle),
                width: 230,
                dataIndex: LessonPlanColumns.Component,
                key: LessonPlanColumns.Component,
                className: "component-column",
                scopedSlots: { customRender: "componentName" }
            },
            {
                title: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanColumnExposureTitle),
                width: 80,
                dataIndex: LessonPlanColumns.Exposure,
                key: LessonPlanColumns.Exposure,
                className: "exposure-column"
            }
        ];
        this.addLessonModalVisible = false;
        this.addLessonButtonLoading = false;
        this.enableaddLessonSaveButton = true;
        this.currentActivities = [];
        this.addLessonFormModel = {
            createLessonPlanCount: 1
        };
        this.createUnitFormRules = {
            createLessonPlanCount: [
                {
                    required: true,
                    message: fmtMsg(LessonPlanLocale.LessonPlanListAddLessonCountRequiredMsg),
                    trigger: "change"
                },
                { validator: this.lessonPlanCountValidator, trigger: "change" }
            ]
        };
        this.labelCol = {
            span: 18
        };
        this.wrapperCol = {
            span: 6
        };
        this.getColumnClassName = (taughtType) => {
            switch (taughtType) {
                case ComponentTaughtType.Normal:
                    return "taught-normal";
                case ComponentTaughtType.Optional:
                    return "taught-optional";
                default:
                    return "";
            }
        };
        this.getColumnClassStyle = (taughtType) => {
            switch (taughtType) {
                case ComponentTaughtType.Normal:
                    return "background-color: #52c41a";
                case ComponentTaughtType.Optional:
                    return "background-color: #fff000";
                default:
                    return "";
            }
        };
    }
    toggleEditModal() {
        this.editModalVisible = !this.editModalVisible;
    }
    onPressEdit() {
        if (this.saveButtonShown) {
            MessageHelper.Confirm(fmtMsg(LessonPlanLocale.LessonPlanMasterPlanWarningSwitch), () => {
                this.masterPlanModule.resetLessonPlanToOrigin();
                this.dataChanged = false;
                this.toggleEditModal();
            }, () => {
                console.log("cancel...");
            });
            return;
        }
        this.toggleEditModal();
    }
    lessonPlanCountValidator(rule, value, callback) {
        if (value <= 0 || value > 50) {
            callback(fmtMsg(LessonPlanLocale.LessonPlanListAddLessonCountErrorText));
        }
        callback();
    }
    validateaddLessonForm(item, isPassed, error) {
        if (isPassed != this.enableaddLessonSaveButton)
            this.enableaddLessonSaveButton = isPassed;
    }
    getRangeArray(start, end) {
        const length = end - start + 1;
        return Array.from({ length }, (_, i) => start + i);
    }
    mounted() {
        this.versionGroupModule.setDisabled(false);
        this.columns.push(...this.masterPlanModule.currentLessons.map((cl) => {
            return this.getUnitColumn(cl.sequence, cl);
        }));
        this.columns.push(this.getExtraColumn());
        this.activityDropdownInfo();
    }
    destroyed() {
        this.versionGroupModule.setDisabled(true);
    }
    beforeRouteLeave(to, from, next) {
        if (this.dataChanged) {
            MessageHelper.Confirm(fmtMsg(CommonLocale.CommonLeaveDirtyWarning), () => {
                if (next) {
                    next();
                }
            }, () => {
                next(false);
            });
        }
        else {
            next();
        }
    }
    get loading() {
        return this.masterPlanModule.loading;
    }
    get commonLocale() {
        return CommonLocale;
    }
    get lessonPlanLocale() {
        return LessonPlanLocale;
    }
    get contentGroup() {
        return ContentGroupEnum;
    }
    get mediaSlot() {
        return MediaSlot;
    }
    get pdfIcon() {
        return PdfIcon;
    }
    get manageTransitionFormTitle() {
        return fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageActivitiesTitle);
        // return this.isREP
        // 	? fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageItemsTitle)
        // 	: fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageTransitionTitle);
    }
    get unitText() {
        return this.masterPlanModule.currentUnit.displayName;
    }
    get methodologyText() {
        return MethodologyTypeItemsWithAll.get(this.masterPlanModule.currentMethodology);
    }
    get isREP() {
        return this.masterPlanModule.isREPMethodology;
    }
    get addButtonText() {
        return this.isREP
            ? this.formatMessage(LessonPlanLocale.LessonPlanPlayListBuilderAddButtonTitle)
            : this.formatMessage(LessonPlanLocale.LessonPlanMasterPlanAddLessonButtonTitle);
    }
    get clearButtonText() {
        return this.formatMessage(LessonPlanLocale.LessonPlanMasterPlanClearButtonTitle);
    }
    get addLessonPlanModalTitle() {
        return this.isREP
            ? fmtMsg(LessonPlanLocale.LessonPlanPlayListAddModalTitle)
            : fmtMsg(LessonPlanLocale.LessonPlanAddModalTitle);
    }
    get addLessonPlanCountLabel() {
        return this.isREP
            ? fmtMsg(LessonPlanLocale.LessonPlanListAddPlaylistCountLabelText)
            : fmtMsg(LessonPlanLocale.LessonPlanListAddLessonCountLabelText);
    }
    get lessonPlanVersionText() {
        return this.masterPlanModule.currentLessonPlanVersion.name;
    }
    get canAddOrModifyLesson() {
        return this.masterPlanModule.currentLessonPlanVersion.status === LessonPlanVersionStatus.Draft;
    }
    get canSaveData() {
        return this.dataChanged;
    }
    get lessonPlans() {
        return this.masterPlanModule.lessonPlans;
    }
    get lessonPlanRowType() {
        return LessonPlanItemType;
    }
    get activityType() {
        return Activity;
    }
    get currentTransitions() {
        return this.masterPlanModule.transitions;
    }
    get currentRepConversations() {
        return this.masterPlanModule.repConversations;
    }
    get currentLessonTransitions() {
        return this.masterPlanModule.currentLessonTransitions;
    }
    get currentConversationSpeed() {
        const speed = this.masterPlanModule.currentLessons.find((cl) => cl.sequence === this.masterPlanModule.currentLessonNumber4ManageTransition)?.conversationSpeed;
        return speed ? speed : 1;
    }
    get currentRouteAccessLevel() {
        return getRouteAccessLevel(this.$route);
    }
    get disabledDueToAccessLevel() {
        return disabledDueToAccessLevel(this.currentRouteAccessLevel);
    }
    get currentLessons() {
        return this.masterPlanModule.currentLessons;
    }
    get saveButtonShown() {
        return this.canSaveData && !this.disabledDueToAccessLevel;
    }
    formatMessage(id, params) {
        return fmtMsg(id, params);
    }
    getLessonPlanItemType(lessonPlanRow, lessonNumber) {
        let lessonPlanItem;
        switch (lessonPlanRow.rowType) {
            case LessonPlanItemType.Component:
                lessonPlanItem = lessonPlanRow.lessonPlanItems?.find((lpi) => lpi.lessonNumber === lessonNumber);
                return {
                    taughtType: lessonPlanItem ? lessonPlanItem.taughtType : ComponentTaughtType.None,
                    lessonSequence: lessonPlanItem ? lessonPlanItem.lessonSequence : undefined
                };
            default:
                return { taughtType: ComponentTaughtType.None };
        }
    }
    getExtraColumn() {
        return {
            title: "",
            dataIndex: LessonPlanColumns.ExtraColumn,
            key: LessonPlanColumns.ExtraColumn
        };
    }
    getMasterPlanLessonPlanEditorRouter(record) {
        const { versionGroupId, lessonPlanVersionId, methodology, unitId } = this.$route.params;
        return GLUtil.pathStringify(Paths.MasterPlanLessonPlanEditor, {
            versionGroupId,
            methodology,
            lessonPlanVersionId,
            unitId,
            lessonPlanId: record.id
        });
    }
    onNavigate2MasterPlanLessonPlanEditor(record) {
        const { versionGroupId, lessonPlanVersionId, methodology, unitId } = this.$route.params;
        this.$router.push({
            path: GLUtil.pathStringify(Paths.MasterPlanLessonPlanEditor, {
                versionGroupId,
                methodology,
                lessonPlanVersionId,
                unitId,
                lessonPlanId: record.id
            })
        });
    }
    getUnitColumn(ck, data) {
        const noneUnitColumnCount = 3;
        const columnKey = ck ? ck : this.columns.length - noneUnitColumnCount + 1;
        const columnTitle = `${columnKey}`;
        const columnName = `${LessonPlanColumns.LessonColumn}${columnKey}`;
        return {
            title: () => {
                return <router-link to={this.getMasterPlanLessonPlanEditorRouter(data)}>{columnTitle}</router-link>;
            },
            dataIndex: LessonPlanColumns.LessonColumn,
            key: columnName,
            className: "lesson-column",
            width: 40,
            customRender: (value, record, index) => {
                switch (record.rowKey) {
                    case EstimatedTimeRowKey:
                        return this.customRender4EstimatedTimeColumn(value, record, index, columnKey);
                    case QuestionOrConversationRowKey:
                    case TransitionRowKey:
                        return this.customRender4TransitionColumn(value, record, index, columnKey);
                    default:
                        return this.customRender4UnitColumn(value, record, index, columnKey);
                }
            },
            customCell: (record, index) => {
                return {
                    on: {
                        click: () => {
                            switch (record.rowKey) {
                                case TransitionRowKey:
                                    this.onTransitionItemClicked(record, index, columnKey);
                                    break;
                                case QuestionOrConversationRowKey:
                                    this.onQuestionConversationItemClicked(record, index, columnKey);
                                    break;
                                case EstimatedTimeRowKey:
                                    break;
                                default:
                                    this.canAddOrModifyLesson &&
                                        !this.disabledDueToAccessLevel &&
                                        this.onLessonPlanItemClicked(record, index, columnKey);
                                    break;
                            }
                        }
                    }
                };
            }
        };
    }
    customRender4EstimatedTimeColumn(value, record, index, columnKey) {
        const obj = {
            children: record.estimatedTime.length > 0
                ? second2Minute(record.estimatedTime[columnKey - 1])
                : "",
            attrs: {}
        };
        return obj;
    }
    customRender4TransitionColumn(value, record, index, columnKey) {
        const currentLessonTransitions = record.lessonPlanItems.filter((lpi) => lpi.lessonNumber === columnKey && true
        // (this.isREP
        // 	? lpi.itemType === LessonPlanItemType.Question || lpi.itemType === LessonPlanItemType.Conversation
        // 	: lpi.itemType === LessonPlanItemType.Transition)
        );
        const taughtType = currentLessonTransitions.length > 0 ? ComponentTaughtType.Normal : ComponentTaughtType.None;
        const props = {
            hasTransitionData: currentLessonTransitions.length > 0,
            sequences: currentLessonTransitions.map((clt) => clt.lessonSequence)
        };
        const obj = {
            children: <TransitionCell {...{ props }}/>,
            attrs: {
                style: this.getColumnClassStyle(taughtType),
                class: `lesson-column ${this.getColumnClassName(taughtType)}`
            }
        };
        return obj;
    }
    customRender4UnitColumn(value, record, index, columnKey) {
        const props = {
            ...this.getLessonPlanItemType(record, columnKey),
            lessonNumber: columnKey
        };
        const obj = {
            children: <LessonPlanCell {...{ props }}/>,
            attrs: {
                style: this.getColumnClassStyle(props.taughtType),
                class: `lesson-column ${this.getColumnClassName(props.taughtType)}`
            }
        };
        return obj;
    }
    getRowClassName(record, index) {
        switch (record.rowKey) {
            case EstimatedTimeRowKey:
                return "estimated-time-row";
            case TransitionRowKey:
                return "transition-row";
            default:
                return "";
        }
    }
    async onAddLesson(event) {
        this.addLessonModalVisible = true;
    }
    onClearLesson() {
        this.dataChanged = true;
        this.masterPlanModule.clearLessonPlans();
    }
    onLessonPlanItemClicked(record, rowIndex, lessonNumber) {
        if (!this.dataChanged) {
            this.dataChanged = record.rowKey !== EstimatedTimeRowKey && record.rowKey !== TransitionRowKey;
        }
        this.masterPlanModule.onLessonPlansChanged({
            lessonPlanRowIndex: rowIndex,
            lessonPlanRow: record,
            lessonNumber,
            lessonPlanItem: record.lessonPlanItems?.find((lpi) => lpi.lessonNumber === lessonNumber)
        });
    }
    onSaveLesson(event) {
        if (this.dataChanged) {
            this.masterPlanModule.onSaveLessonPlans(null);
            this.dataChanged = false;
        }
    }
    onTransitionItemClicked(record, rowIndex, lessonNumber) {
        this.masterPlanModule.setCurrentLesson4ManageTransition(lessonNumber);
        this.masterPlanModule.fetchCurrentLessonTransitions(lessonNumber);
        this.displayTransitionDetail = true;
    }
    onQuestionConversationItemClicked(record, rowIndex, lessonNumber) {
        this.masterPlanModule.setCurrentLesson4ManageTransition(lessonNumber);
        this.masterPlanModule.fetchCurrentLessonTransitions(lessonNumber);
        this.displayTransitionDetail = true;
    }
    onTransitionAdded() {
        this.dataChanged4Detail = true;
    }
    onTransitionRemove(transition) {
        Modal.confirm({
            title: this.isREP
                ? transition.itemType === PlaylistItemType.Question
                    ? fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageQuestionListDeletePromptMessage)
                    : fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageConversationListDeletePromptMessage)
                : fmtMsg(LessonPlanLocale.LessonPlanMasterPlanManageTransitionListDeletePromptMessage),
            okText: fmtMsg(CommonLocale.CommonYesButtonText),
            okType: "danger",
            cancelText: fmtMsg(CommonLocale.CommonNoButtonText),
            onOk: () => {
                this.masterPlanModule.removeLessonTransition(transition);
                this.dataChanged4Detail = true;
            }
        });
    }
    onLessonSequencesChanged(value) {
        this.dataChanged4Detail = true;
        this.masterPlanModule.setCurrentLessonTransitions(value);
    }
    onSaveTransitions() {
        if (this.dataChanged4Detail) {
            this.dataChanged = true;
            const conversationSpeed = this.$refs.transitionDetail.playlistCoversationsSpeed;
            this.masterPlanModule.saveLessonTransition(conversationSpeed);
        }
        this.onCloseManageTransition();
    }
    onCloseManageTransition() {
        this.masterPlanModule.setCurrentSelectedActivity("");
        this.masterPlanModule.setCurrentSelectedActivityId(0);
        this.masterPlanModule.setCurrentLesson4ManageTransition(-1);
        this.displayTransitionDetail = false;
        this.dataChanged4Detail = false;
        this.$refs.transitionDetail.onResetFormFieldsValue();
    }
    onBack() {
        this.$router.push({
            path: GLUtil.pathStringify(Paths.LessonPlanListWithParams, {
                versionGroupId: this.$route.params.versionGroupId,
                methodology: this.$route.params.methodology,
                lessonPlanVersionId: this.$route.params.lessonPlanVersionId
            }),
            query: { unitId: `${this.$route.params.unitId}` }
        });
    }
    onAddLessonModalClose() {
        this.addLessonButtonLoading = false;
        this.addLessonModalVisible = false;
        this.addLessonFormModel.createLessonPlanCount = 1;
    }
    async onAddLessonModalOK() {
        const form = this.$refs.addLessonFormModel;
        form.validate((valid) => {
            if (valid) {
                this.addLessonButtonLoading = true;
                // Get the count of lessonPlans to be added
                const lessonPlanCountToAdd = this.addLessonFormModel.createLessonPlanCount;
                this.masterPlanModule.onAddLessons(lessonPlanCountToAdd).then(() => {
                    const { versionGroupId, methodology, lessonPlanVersionId, unitId } = this.$route.params;
                    this.onAddLessonModalClose();
                    this.masterPlanModule
                        .fetchLessonPlans({
                        versionGroupId: versionGroupId,
                        lessonPlanVersionId: lessonPlanVersionId,
                        unitId: parseInt(unitId, 10),
                        methodology: parseInt(methodology, 10)
                    })
                        .then(() => {
                        const firstTwo = [this.columns[0], this.columns[1]];
                        this.columns = [
                            ...firstTwo,
                            ...this.masterPlanModule.currentLessons.map((cl) => {
                                return this.getUnitColumn(cl.sequence, cl);
                            })
                        ];
                        this.columns.push(this.getExtraColumn());
                    })
                        .catch(() => {
                        this.onAddLessonModalClose();
                    });
                });
            }
        });
    }
    activityDropdownInfo() {
        this.lessonPlanActivitiesService
            .getMasterPlanActivities(this.masterPlanModule.currentLessonPlanVersion.id, this.masterPlanModule.currentUnit.id)
            .then((data) => (this.currentActivities = data));
    }
    get allCurrentActivities() {
        return this.currentActivities;
    }
    onSelectedActivityChange(key, value) {
        this.masterPlanModule.setCurrentSelectedActivity(key);
        this.masterPlanModule.setCurrentSelectedActivityId(value.data.key);
    }
    resetLessonPlanToOrigin() {
        this.masterPlanModule.resetLessonPlanToOrigin();
    }
};
MasterPlanManagement = __decorate([
    Component({
        components: {
            "a-spin": Spin,
            "a-table": Table,
            "a-drawer": Drawer,
            "a-icon": Icon,
            "a-form": Form,
            "a-form-item": Form.Item,
            "a-select": Select,
            "a-select-option": Select.Option,
            Button,
            Drawer,
            PageTitle,
            UnitInfo,
            MatIcon,
            LessonPlanCell,
            TransitionDetail,
            ActionItem,
            Modal,
            Form: FormModel,
            FormItem: FormModel.Item,
            InputNumber,
            SwitchModal,
            TransitionCell
        }
    })
], MasterPlanManagement);
export default MasterPlanManagement;
